import { useMediaQuery } from "customHooks/useMediaQuery";
import { useRef, useState } from "react";
import "./style.scss";

import { SvgButtonArrowLeft } from "assets/icons/js/SvgButtonArrowLeft";
import { SvgButtonArrowRight } from "assets/icons/js/SvgButtonArrowRight";

const Timeline = () => {
	const [scrollX, setscrollX] = useState(0);
	const [scrollEnd, setscrolEnd] = useState(false);
	const listRef = useRef(null);

	const width = useMediaQuery();

	//Slide click
	const slide = (shift) => {
		listRef.current.scrollLeft += shift;
		setscrollX(scrollX + shift);

		if (
			Math.floor(listRef.current.scrollWidth - listRef.current.scrollLeft) <=
			listRef.current.offsetWidth
		) {
			setscrolEnd(true);
		} else {
			setscrolEnd(false);
		}
	};

	const scrollCheck = () => {
		setscrollX(listRef.current.scrollLeft);
		if (
			Math.floor(listRef.current.scrollWidth - listRef.current.scrollLeft) <=
			listRef.current.offsetWidth
		) {
			setscrolEnd(true);
		} else {
			setscrolEnd(false);
		}
	};

	const data = [
		{
			year: "April 2014",
			title: "The First Seeds",
			desc: "SaffronStays launches as an aggregator with 800+ host-listed properties.",
		},

		{
			year: "October 2015",
			title: "The 1st Transformation",
			desc: "Founder Tejas Parulekar painstakingly restores Parsi Manor, a 200-year-old colonial British mansion in Matheran",
		},

		{
			year: "March 2016",
			title: "The Awakening",
			desc: "Tejas identifies the biggest pain point for CXOs and Industrialist Home Owners - giving their homes the attention they deserve",
		},

		{
			year: "July 2016",
			title: "Two’s A Team",
			desc: "After 16 years at Ernst & Young India, 9 of them as Cyber Security Practice Leader (India’s Youngest Partner), Deven Parulekar joins SaffronStays",
		},

		{
			year: "March 2017",
			title: "Restoring History",
			desc: "Tejas and Deven personally restore Milton Abbott, the erstwhile Summer House of the Madras Presidency.",
		},

		{
			year: "May 2017",
			title: "The Team Expands",
			desc: "SaffronStays is now a family of 7 employees, starts getting recognised by media houses.",
		},

		{
			year: "January 2018",
			title: "SaffronStays Select Awards Launched",
			desc: "SaffronStays reaches the corners of India - launches the first ever Vacation Home Awards for private estates across the country",
		},

		{
			year: "August 2018",
			title: "Sixth Sense Ventures Partners WIth SaffronStays",
			desc: "India’s premier consumer-centric venture capital firm invests in SaffronStays",
		},

		{
			year: "June 2019",
			title: "The 100th Home",
			desc: "SaffronStays opens doors to its 100th hand-picked home",
		},

		{
			year: "June 2020",
			title: "The Bounceback",
			desc: "Business flourishes as travelers see safety and luxury in private estates over hotels after the pandemic-driven lockdown eases",
		},

		{
			year: "January 2021",
			title: "LuxeBook Top 100 India’s Most Powerful Brand",
			desc: "Recognised by Luxebook as the only private vacation rental company in its",
		},

		{
			year: "2021",
			title: "Building the Team",
			desc: "SaffronStays hires CDO, CMO and expands teams across the country, gets recognised by top media houses and industry peer bodies",
		},

		{
			year: "March 2022",
			title: "North Expansion",
			desc: "SaffronStays opens doors to 20 exquisite estates in Himachal Pradesh and Uttarakhand",
		},
	];
	return (
		<div className="about-us-timeline">
			<div className="timeline-cover">
				<div className="top">TIMELINE</div>
				<div className="bottomf">We’ve come a long way!</div>
				<div className="timeline-wrapper">
					<div className="destination__scroll-button">
						<span className="button-one" onClick={() => slide(-300)}>
							{scrollX === 0 ? (
								<SvgButtonArrowLeft
									height={width <= "500" ? 22 : 34}
									width={width <= "500" ? 22 : 34}
								/>
							) : (
								<SvgButtonArrowRight
									height={width <= "500" ? 22 : 34}
									width={width <= "500" ? 22 : 34}
									style={{ transform: "rotate(180deg)" }}
								/>
							)}
						</span>
						<span className="button-two" onClick={() => slide(300)}>
							{!scrollEnd ? (
								<SvgButtonArrowRight
									height={width <= "500" ? 22 : 34}
									width={width <= "500" ? 22 : 34}
								/>
							) : (
								<SvgButtonArrowLeft
									height={width <= "500" ? 22 : 34}
									width={width <= "500" ? 22 : 34}
									style={{ transform: "rotate(180deg)" }}
								/>
							)}
						</span>
					</div>
					<div
						className="timeline-container"
						ref={listRef}
						onScroll={scrollCheck}
					>
						{data.map((ele) => (
							<TimelineCard key={ele.year} {...ele} />
						))}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Timeline;

const TimelineCard = ({ year, title, desc }) => {
	return (
		<div className="timeline-card">
			<div className="timeline-year">{year}</div>
			<div className="timeline-title">{title}</div>
			<div className="timeline-desc">{desc}</div>
		</div>
	);
};
